import { tw } from '@/utils/tw';

const Markup = tw.theme({
  base: 'col-span-12 w-full',
});

export default Markup;
